import React from "react";
import { Hero } from "./components/hero";
import { Navbar } from "./components/navbar";

export default function App() {
  return (
    <>
      <Navbar />
      <Hero />
    </>
  );
}
